import {
    DataFlowDatasetSettings,
    DatasetFormatType
} from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { Metamodel, ReadBehavior } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { type DataFlowExpression } from 'app/model/dataflow/dataflowexpression';
import { type DataFlowExpressionArray } from 'app/model/dataflow/dataflow-expression-array';
import { ReadMode } from 'app/model/dataflow/dataset-settings/sap-odp-settings';
import {
    BooleanDataFlowType,
    IntegerDataFlowType,
    StringDataFlowType
} from 'worker/app-workers/shared/models/dataflow-datatype';

@Metamodel.model({
    name: adfModelTypeMap.sapOData.dataflowSettings
})
export class SapODataSettings extends DataFlowDatasetSettings {
    @Metamodel.attribute({
        display: stringResources.ServicePath_Label
    })
    public servicePath: DataFlowExpression;

    @Metamodel.attribute({
        display: stringResources.TableNameDisplay_EntityName
    })
    public entityName: DataFlowExpression;

    @Metamodel.attribute({
        display: stringResources.DataFlowRunMode
    })
    public readMode: DataFlowExpression;

    @Metamodel.attribute({
        display: stringResources.ModelName_BatchSize
    })
    public batchSize: DataFlowExpression;

    @Metamodel.attribute({
        display: stringResources.Timeout
    })
    public timeout: DataFlowExpression;

    @Metamodel.attribute({
        display: stringResources.DataFlowDatasetKeyColumns
    })
    public sapODataKeyColumns: DataFlowExpressionArray;

    @Metamodel.attribute({})
    public browseServicePath: DataFlowExpression;

    public get runMode(): ReadBehavior {
        switch (this.readMode.expression) {
            case ReadMode.FULL_LOAD:
                return ReadBehavior.FULL_ON_EVERY_RUN;
            case ReadMode.FULL_AND_INCREMENTAL_LOAD:
                return ReadBehavior.FULL_ON_FIRST_RUN_THEN_INCREMENTAL;
            case ReadMode.INCREMENTAL_LOAD:
                return ReadBehavior.INCREMENTAL_CHANGES_ONLY;
            default:
                return undefined;
        }
    }

    public getDatasetType(): string {
        // TODO: implement
        return undefined;
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.SapOData;
    }

    public getSubFormat(): string {
        return undefined;
    }

    public getIconClass(): string {
        return 'i-100x100-Sap';
    }

    public initialize(subFormat: string): void {
        this.servicePath = this.transform.createTemplatableExpression();
        this.entityName = this.transform.createTemplatableExpression();
        this.readMode = this.transform.createTemplatableExpression(StringDataFlowType.TYPE, ReadMode.FULL_AND_INCREMENTAL_LOAD);
        this.batchSize = this.transform.createTemplatableExpression(IntegerDataFlowType.TYPE);
        this.timeout = this.transform.createTemplatableExpression(IntegerDataFlowType.TYPE);
        this.sapODataKeyColumns = this.transform.createTemplatableExpressionArray();
        this.browseServicePath = this.transform.createTemplatableExpression(BooleanDataFlowType.TYPE, 'true');
    }
}
